var _a;
export var RESOURCING_PERIOD_CHART_METRICS = {
    WorkloadHours: 'workloadHours',
    ProductiveHours: 'productiveHours',
    ProductionHours: 'productionHours',
    ProductionFTE: 'productionFte',
    ProductiveFTE: 'productiveFte',
    RequiredFTE: 'requiredFte',
    SeatsRequired: 'seatsRequired',
    RequiredHeadcount: 'requiredHeadcount',
    Attrition: 'attrition',
    TotalSupportStaff: 'totalSupportStaff',
};
export var FINANCIAL_PERIOD_CHART_METRICS = {
    TotalBudgets: 'totalBudgets',
    AgentSalaries: 'agentsSalaries',
    SupportStaffSalaries: 'totalSupportStaffSalaries',
    HiringAhead: 'hiringAhead',
    OvertimeCosts: 'overtimeCosts',
    CostPerWork: 'avgCostPerWork',
};
export var RESOURCING_PERIOD_CHART_METRIC_VALUES = [
    RESOURCING_PERIOD_CHART_METRICS.WorkloadHours,
    RESOURCING_PERIOD_CHART_METRICS.ProductionHours,
    RESOURCING_PERIOD_CHART_METRICS.ProductionFTE,
    RESOURCING_PERIOD_CHART_METRICS.RequiredFTE,
    RESOURCING_PERIOD_CHART_METRICS.SeatsRequired,
    RESOURCING_PERIOD_CHART_METRICS.RequiredHeadcount,
    RESOURCING_PERIOD_CHART_METRICS.TotalSupportStaff,
];
export var PROD_HOURS_RESOURCING_PERIOD_CHART_METRIC_VALUES = [
    RESOURCING_PERIOD_CHART_METRICS.Attrition,
    RESOURCING_PERIOD_CHART_METRICS.ProductiveHours,
    RESOURCING_PERIOD_CHART_METRICS.ProductionHours,
    RESOURCING_PERIOD_CHART_METRICS.ProductionFTE,
    RESOURCING_PERIOD_CHART_METRICS.RequiredFTE,
    RESOURCING_PERIOD_CHART_METRICS.RequiredHeadcount,
    RESOURCING_PERIOD_CHART_METRICS.SeatsRequired,
    RESOURCING_PERIOD_CHART_METRICS.TotalSupportStaff,
];
export var FINANCIAL_PERIOD_CHART_METRIC_VALUES = [
    FINANCIAL_PERIOD_CHART_METRICS.TotalBudgets,
    FINANCIAL_PERIOD_CHART_METRICS.AgentSalaries,
    FINANCIAL_PERIOD_CHART_METRICS.SupportStaffSalaries,
    FINANCIAL_PERIOD_CHART_METRICS.HiringAhead,
    FINANCIAL_PERIOD_CHART_METRICS.OvertimeCosts,
    FINANCIAL_PERIOD_CHART_METRICS.CostPerWork,
];
export var CHART_DECIMAL_VALUE = (_a = {},
    _a[RESOURCING_PERIOD_CHART_METRICS.WorkloadHours] = 0,
    _a[RESOURCING_PERIOD_CHART_METRICS.ProductionHours] = 0,
    _a[RESOURCING_PERIOD_CHART_METRICS.ProductionFTE] = 1,
    _a[RESOURCING_PERIOD_CHART_METRICS.ProductiveFTE] = 1,
    _a[RESOURCING_PERIOD_CHART_METRICS.RequiredFTE] = 1,
    _a[RESOURCING_PERIOD_CHART_METRICS.SeatsRequired] = 0,
    _a[RESOURCING_PERIOD_CHART_METRICS.RequiredHeadcount] = 0,
    _a[RESOURCING_PERIOD_CHART_METRICS.Attrition] = 1,
    _a[RESOURCING_PERIOD_CHART_METRICS.TotalSupportStaff] = 1,
    _a[FINANCIAL_PERIOD_CHART_METRICS.CostPerWork] = 2,
    _a);
